import { PatchOwnerInitialInfoQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchOwnerInitialInfo/patchOwnerInitialInfoQuery.type';
import { patchOwnerInitialInfoFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchOwnerInitialInfo/patchOwnerInitialInfoQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const usePatchOwnerInitialInfoQueryOptions = () =>
  useMutation({
    mutationKey: ['PatchOwnerInitialInfoQuery'],
    mutationFn: (params: PatchOwnerInitialInfoQueryParamsType) =>
      patchOwnerInitialInfoFunction(params),
  });
